import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-detail-scale-info',
  templateUrl: './detail-scale-info.component.html',
  styleUrls: ['./detail-scale-info.component.scss']
})
export class DetailScaleInfoComponent implements OnInit {

  @Input() segment;
  constructor() { }

  ngOnInit() {
  }

}
